import { PilaH, PilaV, Texto } from '@/components/atomos';
import { InfoBannerHome } from '@/models/respuestas/usuario.model';
import { Skeleton } from '@chakra-ui/react';
import { CircleCheck, CircleX } from 'lucide-react';
import { FC, PropsWithChildren } from 'react';

interface PropsInfoEstadoCuenta
  extends Pick<InfoBannerHome, 'perfil' | 'enrolado'> {
  cargando: boolean;
}

interface PropsCheckInfoPerfil extends PropsWithChildren {
  checkeado: boolean;
  cargando: boolean;
}

const CheckInfoPerfil: FC<PropsCheckInfoPerfil> = ({
  checkeado,
  children,
  cargando,
}) => {
  return (
    <Skeleton isLoaded={!cargando}>
      <PilaH spacing={1}>
        {checkeado ? (
          <CircleCheck size='18' color='var(--bGreen-600)' />
        ) : (
          <CircleX size='18' color='var(--destructive-400)' />
        )}
        <Texto color='foreground-secondary'>{children}</Texto>
      </PilaH>
    </Skeleton>
  );
};

const InfoEstadoCuenta: FC<PropsInfoEstadoCuenta> = ({
  cargando,
  enrolado,
  perfil,
}) => {
  return (
    <PilaV alignItems='start' spacing={1}>
      <Skeleton isLoaded={!cargando}>
        <Texto fontWeight={'semibold'} fontSize={'lg'}>
          Estado de la cuenta
        </Texto>
      </Skeleton>
      <CheckInfoPerfil checkeado={enrolado} cargando={cargando}>
        Clave SII
      </CheckInfoPerfil>
      <CheckInfoPerfil checkeado={perfil.tieneDomicilio} cargando={cargando}>
        Domicilio
      </CheckInfoPerfil>
      <CheckInfoPerfil checkeado={perfil.tieneTelefono} cargando={cargando}>
        Números de contacto
      </CheckInfoPerfil>
    </PilaV>
  );
};

export default InfoEstadoCuenta;
